import React from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import moment from "moment";

import ReportPaymentsInvoices from "../../../validations/ReportPaymentsInvoices";
import { ReportOperatorSalary } from "../../../models/ReportOperatorSalary";

import axiosClient from "../../../config/axios";

import OrdersInvoicesReportForm from "../../../forms/ordersInvoicesReportForm";
import TableOrderInvoicesReport from "../../../components/reports/TableOrderInvoicesReport";

import Loader from "../../../components/loader";

const OrdersInvoicesReportVaroExpress = () => {
  const [loading, setLoading] = React.useState(true);
  const [records, setRecords] = React.useState([]);
  const [orders, setOrders] = React.useState([]);
  const [invoices, setInvoices] = React.useState([]);
  const [vehicleTypes, setVehicleTypes] = React.useState([]);

  const [status, setStatus] = React.useState([]);
  const [paymentTypes, setPaymentTypes] = React.useState([]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...ReportOperatorSalary(),
      paymentTypes: "all",
      companyType: "all",
      vehicleTypeId: "all",
    },
    validationSchema: ReportPaymentsInvoices,

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const invoiceStart = values.start
          ? moment(values.start).format("YYYY-MM-DD")
          : "";
        const invoiceEnd = values.end
          ? moment(values.end).format("YYYY-MM-DD")
          : "";
        const paymentType = values.paymentTypes || "all";

        //const companyType = values.companyType || "all";
        const companyType = "Varo Express";
        const vehicleTypeId = values.vehicleTypeId || "all";

        const endpoint = `/reports/invoices?invoiceStart=${invoiceStart}&invoiceEnd=${invoiceEnd}&paymentTypeFilterCode=${paymentType}&invoice_disabled=false&companyType=${companyType}&vehicleTypeId=${vehicleTypeId}`;
        const { data } = await axiosClient.get(endpoint);

        const invoices = data?.invoices || [];

        // Ordenar por fecha de factura
        invoices.sort(
          (a, b) => new Date(a.invoice_date) - new Date(b.invoice_date)
        );

        setRecords(invoices);
        setOrders(invoices);
        setInvoices(invoices);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchData = async () => {
    try {
      // Fetch statuses
      const responseStatus = await axiosClient.get(
        "/orderStatuses/allWithOrderCount"
      );
      const formattedOptionsStatus = [
        { value: "all", label: "Todas las opciones" },
        ...responseStatus.data.data.map((operator) => ({
          label: operator.order_status,
          value: operator.order_status,
        })),
      ];
      setStatus(formattedOptionsStatus);

      // Fetch vehicle types
      const responseVehicleTypes = await axiosClient.get("/vehicleTypes/all");

      const uniqueTypes = [];
      const seen = new Set();

      responseVehicleTypes.data.data.forEach((vt) => {
        // Normaliza para evitar diferencias de acentos/mayúsculas
        const normalized = vt.vehicle_type_name
          .normalize("NFD") // separa letras y acentos
          .replace(/[\u0300-\u036f]/g, "") // elimina acentos
          .toUpperCase();

        if (!seen.has(normalized)) {
          seen.add(normalized);
          uniqueTypes.push({
            label: vt.vehicle_type_name,
            value: vt.vehicle_type_name,
          });
        }
      });

      const formattedVehicleTypes = [
        { value: "all", label: "TODOS" },
        ...uniqueTypes,
      ];

      setVehicleTypes(formattedVehicleTypes);

      // Fetch payment types
      const responsePaymentTypes = await axiosClient.get("/paymentTypes/all");
      const formattedPaymentTypes = [
        { value: "all", label: "TODOS" },
        ...responsePaymentTypes.data.data.map((pt) => ({
          label: pt.payment_type_name,
          value: pt.payment_type_code,
        })),
      ];

      setPaymentTypes(formattedPaymentTypes);
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    formik.handleSubmit();
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Loader isLoading={loading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item active">Reporte de facturas Varo Express</li>
          </ol>
          <h1 className="page-header mb-0">Reporte de facturas Varo Express</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12 card border-0 p-3">
          <OrdersInvoicesReportForm
            formik={formik}
            records={records}
            status={status}
            paymentTypes={paymentTypes}
            invoices={invoices}
            vehicleTypes={vehicleTypes}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 card border-0 p-3">
          <TableOrderInvoicesReport
            orders={orders}
            invoices={invoices}
            start={formik.values.start}
            end={formik.values.end}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrdersInvoicesReportVaroExpress;
